































































































































import { Component, Vue } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import GenericEdit from "@/core/Generics/GenericEdit";
import Annoucement from "@/models/annoucement/annoucementPublish.Model";
import Language from "@/models/language/language.model";
import AnnoucementService from "@/services/Annoument.service";
import { Watch } from "vue-property-decorator";
import AnnoucementPublish from "@/models/annoucement/annoucementPublish.Model";
import UserService from "@/services/user.service";

import moment from "moment";
@Component
export default class AnnoucementDetail extends BaseVue {
  annoucementService = new AnnoucementService();
  userService: UserService = new UserService();
  loading = false;
  annoucement = new Annoucement();
  annoucementId = "";
  isExpired = 1;
  isStillDontOpen = false;
  day =  null;
  isInvestigator = false;
  userName = "";
  userLastName = "";
  expired = null;
  userRequested = {};
  dateObj = {
    seconds: "",
    days: "",
    hours: "",
    months: "",
    minutes: "",
    years: "",
    year: ""
  };
  timer: any = "";
  resultDateFilnal: Boolean;
  isNotResearcher: Boolean;

  moment: any = moment;
  constructor() {
    super();
    this.resultDateFilnal = false;
    this.isNotResearcher = false;
    // this.getUser();
  }

  @Watch("expired")
  onDateChange() {
    
    if (this.expired == this.isExpired && this.isStillDontOpen) {
      return this.$buefy.notification.open({
        duration: 10000,
        message: "Esta convocatoria ya ha finalizado",
        position: "is-bottom-right",
        type: "is-warning",
        hasIcon: true
      });
    }else{
       return this.$buefy.notification.open({
        duration: 10000,
        message: "Aun no puede aplicar a esta convocatoria",
        position: "is-bottom-right",
        type: "is-warning",
        hasIcon: true
      });
    }
  }
  applyProposal() {
    if (!this.isInvestigator) {
      this.isNotResearcher = true;
      this.$buefy.dialog.confirm({
        title: "Enviar solicitud de investigador",
        message:
          "Hola " +
          ` <b>${this.userName}` +
          " " +
          `${this.userLastName}</b>` +
          " Necesita ser un investigador para poder aplicar a esta convocatoria.  " +
          "<b>¿Desea solicitar el rol de investigador en este momento?</b>",
        confirmText: "Solicitar",
        cancelText: "En otro momento",
        type: "is-warning",
        hasIcon: true,
        size: "is-medium",
        onConfirm: () => {
          this.$store.commit("setOpenAddRequesRoleModal", true);
        }
      });
      return;
    }
    this.$router.push(`/convocatoria/${this.annoucementId}/propuesta`);
  }
  mounted() {
    this.annoucementId = this.$route.params.id;
    this.getDetail();
    this.getcenterByInvestigatorId();
    this.getUserBy();
    setInterval(() => {
      var countdownObj = this.moment(this.annoucement.dateEnd).countdown();
      this.dateObj.days = countdownObj.days;
      this.dateObj.minutes = countdownObj.minutes;
      this.dateObj.months = countdownObj.months;
      this.dateObj.seconds = countdownObj.seconds;
      this.dateObj.hours = countdownObj.hours;
      this.dateObj.years = countdownObj.years;
      this.dateObj.year = countdownObj.year;

      this.timer = this.moment(this.annoucement.dateEnd)
        .countdown()
        .toString()
        .replace("year", "Año")
        .replace("years", "Años")
        .replace("days", "Dias")
        .replace("month", "Mes")
        .replace("month", " Mese")
        .replace("hours", "Horas")
        .replace("minutes", "Minutos")
        .replace("minute", "Minutos")
        .replace("day", "Dias")
        .replace("hour", "Horas")
        .replace("seconds", "Segundos")
        .replace("second", "Segundos")
        .replace("and", "");
    }, 1000);
  }

  get user() {
    return this.$store.state.user;
  }

  public getDetail() {
    this.loading = true;
    this.annoucementService
      .getDetailAnnocement(this.annoucementId)
      .then(response => {
        this.annoucement = response;
        

          var now = moment(new Date(), "YYYY-MM-DD");
              let result =  moment(now).isAfter(response.dateOpen);
          if(!result){
          var dateStart = moment(response.dateOpen, "YYYY-MM-DD");
          var value = moment.duration(now.diff(dateStart)).asDays();
          let number = Math.abs(Math.round(value));
          this.day = number;
          }
          if(!result){
            this.expired = 1;
          }else{
            this.isStillDontOpen =  true;
          }
          if(response.expired == 1){
           this.expired = response.expired;
          }
        this.timer = this.moment(this.annoucement.dateEnd)
          .countdown()
          .toString();
      })
      .finally(() => {
        this.loading = false;
      });
  }

  public isResearcher() {}

  getUserBy() {
    this.userService.getUserById(this.user.id).then(user => {
      this.userRequested = user;
      let promise = user;
      this.userName = user.name;
      this.userLastName = user.lastName;
    });
  }

  public getcenterByInvestigatorId() {
    if (this.userService) {
      this.loading = true;
      this.userService
        .GetInvestigatorRol(this.user.id)
        .then(response => {
          this.isInvestigator = response;
        });
    }
  }
}
